module.exports = __webpack_public_path__ + "static/img01__sp-e439ccf66e20d03529c9f54b2b42b325.svg";